module.exports = __webpack_public_path__ + "static/media/police-box.6221bd3f.svg";